import React, { useState, useEffect } from 'react';
import { FiBarChart2, FiFilter, FiX, FiTrendingUp, FiUsers, FiAlertTriangle } from 'react-icons/fi';
import resourceAllocationService from '../../services/resourceAllocationService';
import './ResourceAllocationList.css';
import { toast } from 'react-toastify';
import { FaFileExcel } from 'react-icons/fa';
import taskService from '../../services/taskService';

const ResourceUtilizationDashboard = () => {
  const [utilization, setUtilization] = useState(null);
  const [allocations, setAllocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const [users, setUsers] = useState([]);
  const [filters, setFilters] = useState({
    start_date: '',
    end_date: '',
    user_id: '',
  });

  useEffect(() => {
    loadUtilization();
    loadAllocations();
    loadUsers();
  }, [filters]);

  console.log("users===", users)

  const loadUtilization = async () => {
    try {
      setLoading(true);
      const params = {};
      if (filters.start_date) params.start_date = filters.start_date;
      if (filters.end_date) params.end_date = filters.end_date;
      if (filters.user_id) params.user_id = filters.user_id;

      const data = await resourceAllocationService.getUtilization(params);
      setUtilization(data.data);
      console.error('data-data111===', data);
    } catch (error) {
      console.error('Error loading utilization:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadAllocations = async () => {
    try {
      const params = {
        limit: 100,
        sort_by: 'allocation_percentage',
        sort_order: 'DESC'
      };
      if (filters.start_date) params.start_date = filters.start_date;
      if (filters.end_date) params.end_date = filters.end_date;
      if (filters.user_id) params.user_id = filters.user_id;

      const data = await resourceAllocationService.getAll(params);
      setAllocations(data.data || []);
    } catch (error) {
      console.error('Error loading allocations:', error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleClearFilters = () => {
    setFilters({
      start_date: '',
      end_date: '',
      user_id: ''
    });
  };

  const getUtilizationColor = (percentage) => {
    if (percentage >= 100) return 'badge-danger';
    if (percentage >= 80) return 'badge-success';
    if (percentage >= 50) return 'badge-warning';
    return 'badge-info';
  };

    const getUtilizationTextColor = (percentage) => {
    if (percentage >= 100) return 'text-blue-900';
    if (percentage >= 80) return 'text-green-900';
    if (percentage >= 50) return 'text-yellow-900';
    return 'text-gray-900';
  };


  const groupAllocationsByUser = () => {
    const userMap = {};
    allocations.forEach(allocation => {
      const userId = allocation.user_id;
      if (!userMap[userId]) {
        userMap[userId] = {
          user: allocation.user,
          totalAllocation: 0,
          projects: []
        };
      }
      userMap[userId].totalAllocation += parseFloat(allocation.allocation_percentage || 0);
      userMap[userId].projects.push(allocation);
    });
    return Object.values(userMap).sort((a, b) => b.totalAllocation - a.totalAllocation);
  };

  const userUtilization = groupAllocationsByUser();

const handleDownloadResourceUtilization = () => {
  if (!userUtilization || userUtilization.length === 0) {
    toast.error('No resource utilization data to download');
    return;
  }

  const headers = [
    'Employee', 'Email', 'Total Allocation %', 'Project', 'Role', 'Project Allocation %'
  ];

  const escapeCsv = (value) => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const rows = userUtilization.flatMap((item) =>
    item.projects.map((allocation) => [
      `${item.user?.first_name || ''} ${item.user?.last_name || ''}`.trim(),
      item.user?.email || '',
      item.totalAllocation.toFixed(0),
      allocation.project?.name || 'Unknown Project',
      allocation.role || 'No Role',
      allocation.allocation_percentage
    ])
  );

  const csvContent = [headers, ...rows]
    .map((row) => row.map(escapeCsv).join(','))
    .join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `resource-utilization-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  toast.success('Resource utilization downloaded');
};

 const loadUsers = async () => {
    try {
      const data = await taskService.getAll();
      console.log("users", data)
      setUsers(data.users || []);
    } catch (error) {
      console.error('Error loading users:', error);
    }
  };

  return (
    <div className="resource-allocation-list">
      {utilization && (
        <div className="statistics-cards">
          <div className="stat-card">
            <div className="stat-icon">
              <FiUsers />
            </div>
            <div className="stat-content">
              <div className="stat-value">{utilization.total_resources || 0}</div>
              <div className="stat-label">Total Resources</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon success">
              <FiTrendingUp />
            </div>
            <div className="stat-content">
              <div className="stat-value">{utilization.fully_allocated || 0}</div>
              <div className="stat-label">Fully Allocated</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon warning">
              <FiAlertTriangle />
            </div>
            <div className="stat-content">
              <div className="stat-value">{utilization.over_allocated || 0}</div>
              <div className="stat-label">Over-allocated</div>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon info">
              <FiBarChart2 />
            </div>
            <div className="stat-content">
              <div className="stat-value">{utilization.average_utilization || 0}%</div>
              <div className="stat-label">Avg Utilization</div>
            </div>
          </div>
        </div>
      )}

      <div className="list-header">
        <div className="header-left">
          <h2>Resource Utilization</h2>
          <span className="count">{userUtilization.length} resources</span>
        </div>
        <div className="header-right">
          <button className="btn-icon" onClick={() => setShowFilters(!showFilters)}>
            <FiFilter />
          </button>
            <button
            className="px-4 py-3 bg-white border border-green-600 text-green-600 rounded-lg flex items-center gap-2"
            onClick={handleDownloadResourceUtilization}
            title="Download resource utilization"
          >
            <FaFileExcel />
          </button>
        </div>
      </div>

      {showFilters && (
        <div className="filters-panel">
          <div className="grid md:grid-cols-3">
            <div className="form-group">
              <label>Start Date</label>
              <input
                type="date"
                name="start_date"
                value={filters.start_date}
                onChange={handleFilterChange}
              />
            </div>
            <div className="form-group">
              <label>End Date</label>
              <input
                type="date"
                name="end_date"
                value={filters.end_date}
                onChange={handleFilterChange}
              />
            </div>
            <div className="form-group">
  <label htmlFor="user_id">Users</label>

  <select
    id="user_id"
    name="user_id"
    value={filters.user_id || ""}
    onChange={handleFilterChange}
    className="scroll-md"
  >
    <option value="">Select</option>

    {Array.isArray(users) &&
      users.map((item) => (
        <option key={item.id} value={item.id}>
          {item.first_name} {item.last_name}
        </option>
      ))}
  </select>
</div>
          </div>
          <div className="filters-actions">
            <button className="btn btn-secondary" onClick={handleClearFilters}>
              <FiX /> Clear Filters
            </button>
          </div>
        </div>
      )}

      {loading ? (
        <div className="loading">Loading utilization data...</div>
      ) : userUtilization.length === 0 ? (
        <div className="empty-state">
          <FiBarChart2 size={48} />
          <h3>No Utilization Data</h3>
          <p>No resource allocations found for the selected period</p>
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Employee
                </th>

                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Email
                </th>

                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Utilization
                </th>

                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Projects
                </th>
              </tr>
            </thead>

            <tbody className="bg-white divide-y divide-gray-200">
              {userUtilization.map((item, index) => {
                const isOverAllocated = item.totalAllocation > 100;
                const utilizationColor = getUtilizationColor(item.totalAllocation);
                const utilizationTextColor = getUtilizationTextColor(item.totalAllocation);

                return (
                  <tr key={item.user?.id || index} className="hover:bg-gray-50">
                    {/* Employee */}
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="h-10 w-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold">
                            {}
                            {item.user?.avatar_url ? (
                              <img
                                src={item.user.avatar_url}
                                alt={`${item.user.first_name} ${item.user.last_name}`}
                                className="w-full h-full rounded-full object-cover"
                              />
                            ) : (
                              <>
                                {item.user?.first_name?.[0]}
                                {item.user?.last_name?.[0]}
                              </>
                            )}
                        </div>

                        <div className="ml-3">
                          <div className="text-sm font-medium text-gray-900">
                            {item.user?.first_name} {item.user?.last_name}
                          </div>
                        </div>
                      </div>
                    </td>

                    {/* Email */}
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                      {item.user?.email}
                    </td>

                    {/* Utilization */}
                    <td className="px-6 py-4 min-w-[260px]">
                      <div className="flex items-center gap-3">
                        <div className="w-48 h-2 bg-gray-200 rounded-full overflow-hidden">
                          <div
                            className={`h-full rounded-full ${utilizationColor}`}
                            style={{
                              width: `${Math.min(item.totalAllocation, 100)}%`,
                            }}
                          />
                        </div>

                        <span
                          className={`text-sm font-semibold flex items-center gap-1 ${utilizationTextColor}`}
                        >
                          {item.totalAllocation.toFixed(0)}%

                          {isOverAllocated && (
                            <FiAlertTriangle className="text-red-500" />
                          )}
                        </span>
                      </div>
                    </td>

                    {/* Projects */}
                    <td className="px-6 py-4">
                      <div className="space-y-2">
                        {item.projects.slice(0, 1).map((allocation) => (
                          <div
                            key={allocation.id}
                            className="flex items-center justify-between px-3 py-2"
                          >
                            <div>
                              <p className="text-sm font-medium text-gray-800">
                                {allocation.project?.name || "Unknown Project"}
                                <span className="text-gray-500">
                                  {" "}({allocation.role || "No Role"})
                                </span>
                              </p>
                            </div>

                             {item.projects.length > 1 && (
                          <div className="relative inline-block group pl-3">
                            <span className="cursor-pointer rounded-full !z-0 bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-700 hover:bg-gray-200">
                              +{item.projects.length - 1}&nbsp;more
                            </span>

                            {/* Tooltip */}
                            <div className="absolute left-[-45%] top-6 z-999 hidden min-w-[12rem] rounded-lg border border-gray-200 bg-white p-1 p-2 shadow-xl group-hover:block">
                              <div className="space-y-2">
                                {item.projects.slice(1).map((allocation) => (
                                  <div
                                    key={allocation.id}
                                    className="flex items-center justify-between border-b last:border-b-0 pb-2 last:pb-0"
                                  >
                                    <div>
                                      <p className="text-sm font-medium text-gray-800">
                                        {allocation.project?.name || "Unknown Project"}
                                      </p>
                                      <p className="text-xs text-gray-500">
                                        {allocation.role || "No Role"}
                                      </p>
                                    </div>

                                    <span
                                      className={`rounded-full px-2 py-1 text-xs font-semibold ${resourceAllocationService.getUtilizationBadgeColor(
                                        allocation.allocation_percentage
                                      )}`}
                                    >
                                      {allocation.allocation_percentage}%
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                            <span
                              className={`rounded-full px-2 py-1 text-xs font-semibold ${resourceAllocationService.getUtilizationBadgeColor(
                                allocation.allocation_percentage
                              )}`}
                            >
                              {allocation.allocation_percentage}%
                            </span>
                          </div>
                        ))}

                       
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ResourceUtilizationDashboard;

// ---